/* Thumbnail -> Globo variant selection, scoped to each product component. */
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('button.thumbnail');
  if (!thumbnail) return;
  const component = thumbnail.closest('[data-js-product-component]');
  const data = component && component.querySelector('[data-lifestyle-variant-images]');
  if (!data) return;
  let variants;
  try { variants = JSON.parse(data.textContent); } catch (_) { return; }
  const image = thumbnail.querySelector('img');
  const variant = variants.find((candidate) => {
    if (candidate.media && String(candidate.media) === thumbnail.dataset.lifestyleMediaId) return true;
    if (!candidate.image || !image) return false;
    const file = candidate.image.split('?')[0].split('/').pop().split('.')[0];
    return file && (image.currentSrc || image.src).includes(file);
  });
  if (!variant) return;
  const label = component.querySelector(`label[for*="${variant.id}"]`) || document.querySelector(`label[for*="${variant.id}"]`);
  if (label) label.click();
});
